module.exports = __webpack_public_path__ + "img/public/siteImages/successCheck.png?d975dce1";